export const accountInfoPopoverContent = [
	{
		title: 'paymentConsent.dialog.accountInformation.profile',
		content: 'paymentConsent.dialog.accountInformation.profileContent',
	},
	{
		title: 'paymentConsent.dialog.accountInformation.summary',
		content: 'paymentConsent.dialog.accountInformation.summaryContent',
	},
	{
		title: 'paymentConsent.dialog.accountInformation.transactions',
		content: 'paymentConsent.dialog.accountInformation.transactionsContent',
	},
];
export const dynamicPurposePopoverContentGenerator = (code, category, t) => {
	return [
		{
			title: t('paymentConsent.dialog.consentPurpose.code'),
			content: code,
		},
		{
			title: t('paymentConsent.dialog.consentPurpose.category'),
			content: category,
		},
		{
			title: t('paymentConsent.dialog.consentPurpose.help'),
			content: 'support@cookiejar.co.in',
		},
	];
};
